import Vue from 'vue';
import Vuex from 'vuex';

import error from './error.module';
import auth from './auth.module';
import event from './event.module';
import option from './option.module';
import league from './league.module';
import addons from './addons.module';
import screens from './screens.module';
import createPersistedState from 'vuex-persistedstate';
import createMutationsSharer from 'vuex-shared-mutations';

Vue.use(Vuex);

window.localStorage.removeItem('dtvstore5');
if (process.env.MIX_BETA_FEATURES == 'true') {
    window.localStorage.removeItem('dtvstore6');
}
export default new Vuex.Store({
    modules: {
        error,
        auth,
        event,
        option,
        league,
        addons,
        screens,
    },
    plugins: [
        createPersistedState({
            key: 'dtvstore6'
        }),
        createMutationsSharer({ predicate: ['logout','setUser'] })
    ]
});